<template>
  <div class="modal" v-if="modalVisible" @click="hideModal">
    <div @click.stop class="modal-content">
      <div v-if="!isSent" style="padding: 20px;">
        <div class="m-header">
          <h3 class="m-header-text">Send feedback</h3>
          <img class="close-modal-img" src="/images/close.png" @click="hideModal"/>
        </div>
        <div class="divider"></div>
        <textarea class="feedback-text" placeholder="Add your feedback here..." v-model="comment"></textarea>
        <div class="additional-text mb-15">
          By reporting any feedback, also your actual selection will be submitted to us in order to be able to contextualize the error to any given input.        
        </div>
        <div class="divider"></div>
        <div class="actions-btns">
          <simple-button type="secondary" @click.native="hideModal">
            Cancel
          </simple-button>
          <simple-button style="margin-left: 20px;" type="primary" @click.native="sendReport">
            Send
          </simple-button>
        </div>
      </div>
      <div v-else>
        <div class="send-header">
          <img class="envelope-img" src="/images/envelope.png" />
        </div>
        <div class="mb-15 mt-15">
          <div class="m-header-text text-center mbottom-5">Feedback has been sent successfully</div>
          <div class="additional-text text-center">
            Your Feedback has been submitted to us.
            <br/>
            We appreciate your valuable input!
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { Prop, Vue, Component, Watch } from "vue-property-decorator";
import SimpleButton from './SimpleButton.vue';
import { Answer } from "@/entities/questionaire/answers/Answer";
import { HttpHandler } from "@/http/HttpHandler";
import { Treatment } from "@/entities/Treatment";
import { SelfcheckReport } from "@/entities/SelfcheckReport";
import store from "@/store/index";

@Component({
  name: 'FeedbackModal',
  components: {
    SimpleButton,
  }
})
export default class FeedbackModal extends Vue {
  @Prop()
  modalVisible!: Boolean;

  @Prop()
  answers!: Answer[];

  @Prop()
  treatmentHistory!: Treatment[] | null;

  @Prop()
  excludedRecommendations!: {
    id: number;
    name: string;
    approvalPercentage: number;
  }[];

  @Prop()
  branchId!: number;

  isSent: Boolean = false;
  comment: string = '';

  @Watch('modalVisible')
  setTypeOfModal() {
    if (!this.modalVisible) {
      this.isSent = false;
    }
  }

  hideModal() {
    this.$emit('update:modalVisible', false);
    this.comment = '';
  }

  async sendReport() {
    const httpHandler = new HttpHandler(store);
    await httpHandler.postSelfCheckReport(
      new SelfcheckReport(
        this.branchId,
        false,
        this.answers,
        this.treatmentHistory,
        this.excludedRecommendations,
        this.comment
      )
    );
    
    this.isSent = true;
    this.comment = '';
    setTimeout(() => this.hideModal(), 3000);
  }
}
</script>

<style lang="scss" scoped>
.modal {
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.5);
  position: fixed;
  display: flex;
}
  
.modal-content {
  margin: auto;
  background: white;
  border-radius: 12px;
  min-height: 183px;
  min-width: 300px;
  max-width: 525px;
  border: 1px solid #FFFFFF;
}

.m-header {
  display: flex;
  justify-content: space-between;
}

.m-header-text {
  font-size: 18px;
  font-weight: 600;
}

.close-modal-img {
  width: 16px;
  height: 16px;
  cursor: pointer;
}

.feedback-text {
  resize: none;
  max-width: 484px;
  height: 128px;
  border: 1px solid #E2E4EB;
  border-radius: 8px;
  padding: 10px;
  margin-top: 15px;
  margin-bottom: 10px;
  width: 100%;
}

.feedback-text:focus {
  outline: none;
  border: 1px solid #8D939E;
}

.additional-text {
  font-size: 14px;
  font-weight: 400;
}

.divider {
  height: 1px;
  max-width: 485px;
  background-color: #DAE0EA;
}

.actions-btns {
  display: flex;
  justify-content: end;
  margin-top: 15px;
}

.send-header {
  background: #47B881;
  height: 78px;
  border-radius: 12px 12px 0 0;
}

.envelope-img {
  margin: auto;
  display: block;
  top: 20px;
  position: relative;
}

.mbottom-5 {
  margin-bottom: 5px;
}

.mb-15 {
  margin-bottom: 15px;
}

.mt-15 {
  margin-top: 15px;
}
</style>
